import {
    PLATFORMS_FETCH,
    PLATFORMS_IS_FETCING,
    PLATFORMS_API,
    PLATFORM_EDIT,
    PLATFORM_FILTER,
} from 'constants/platforms'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

//Save Platforms
export const platformSave = (data) => (dispatch, state) => {
    let action;
    if (data.platformId)
        action = put;
    else
        action = post;
    dispatch(plaformsIsFetching(true))
    return action(PLATFORMS_API, data)
        .then((e) => { dispatch(plaformsIsFetching(false)); return e; })
        .catch((e) => { dispatch(plaformsIsFetching(false)); throw new Error(e) })
}



//Feth platform by id
export const platformFetch = (id) => (dispatch, state) => {
        dispatch(plaformsIsFetching(true));
        return get(PLATFORMS_API + '/' + id)
            .finally(e => dispatch(plaformsIsFetching(false)))

    }
    //Feth all platforms
export const plaformsFetch = () => (dispatch, state) => {
    dispatch(plaformsIsFetching(true));
    const filter = state().platforms.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    return get(PLATFORMS_API, {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        })
        .then((e) => {
            dispatch(plaformsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                plaformFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(plaformsIsFetching(false)))

}


//Remove one platform
export const platformRemove = (id) => (dispatch, state) => {
    dispatch(plaformsIsFetching(true))
    return remove(PLATFORMS_API + '/' + id)
        .finally(e => dispatch(plaformsIsFetching(false)))


}
export const plaformsFetched = (payload) => ({ type: PLATFORMS_FETCH, payload: payload })
export const plaformsIsFetching = (payload) => ({ type: PLATFORMS_IS_FETCING, payload: payload })
export const plaformEdit = (id, data) => ({ type: PLATFORM_EDIT, payload: data })
export const plaformFilter = (data) => ({ type: PLATFORM_FILTER, payload: data })


// WEBPACK FOOTER //
// ./src/actions/platforms.js